import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Document from '../../../components/document';
import { FormattedMessage } from 'react-intl';
import { getSubmittedI9, inviteWitness } from './../../../reducers/i9s';
import { InviteWitnessButton } from '../../../components/richButtons';
import { DocumentInfo, PERMISSIONS } from '../../../utilities/documentTypes';

class ContractorI9 extends React.Component {
    componentDidMount() {
        const { profile, getSubmittedI9 } = this.props;

        getSubmittedI9(profile.id);
    }

    render() {
        const { role, i9 } = this.props;
        const { ADMIN_I9, CONTRACTOR_USA_I9_SIGNED } = DocumentInfo.types;

        return (
            <div>
                <div className="row section">
                    <div className="col-xs-12">
                        <FormattedMessage id={'contractor.docs.intro1'} defaultMessage={'Download filled I9 form:'} tagName={'p'} />
                    </div>
                    <div className="col-xs-12">
                        <Document {...ADMIN_I9} id={`${role.id}-${role.type}-download`} view={{ showHeader: false }} />
                    </div>
                </div>
                <div className="row section">
                    <div className="col-xs-12">
                        <FormattedMessage id={'contractor.docs.intro2'} defaultMessage={'Upload signed I9 form:'} tagName={'p'} />
                    </div>
                    <div className="col-xs-12">
                        <Document
                            {...CONTRACTOR_USA_I9_SIGNED}
                            id={`${role.id}-${role.type}-upload`}
                            upload={{ limit: 1, permissions: PERMISSIONS.DEFAULT }}
                            view={{ showHeader: false }}
                        />
                    </div>
                </div>
                <div className="row section">
                    <div className="col-xs-12">
                        <InviteWitnessButton
                            i9={i9}
                            button={action => (
                                <div className="invite-i9-button" onClick={action}>
                                    <FormattedMessage id={'contractor.docs.intro2'} defaultMessage={'Invite a witness to esign'} />
                                </div>
                            )}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    role: state.identity.role,
    profile: state.identity.profile,
    i9: state.i9s.i9
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            getSubmittedI9,
            inviteWitness
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(ContractorI9);



// WEBPACK FOOTER //
// ./src/pages/documents/tabs/contractorI9.jsx